import { mapGetters } from 'vuex'
import Vue from 'vue'
window._showI18nCode = false

Vue.mixin({
  computed: {
    ...mapGetters(['messages'])
  }
})

document.addEventListener(
  'keyup',
  function(e) {
    if (e.key === '`' && e.ctrlKey && e.altKey && e.shiftKey) {
      if (window.showI18nCode) {
        window.showI18nCode()
      }
    }
    if (window._eventHub) {
      window._eventHub.$emit('keyup', e)
    }
  },
  false
)

export default ({ app, store }, inject) => {
  const i18n = {
    get locale() {
      return localStorage.locale
    },
    set locale(locale) {
      if (localStorage.locale === locale && store.state.messages[locale]) {
        return
      }

      if (
        store.state.loading_locales.indexOf(locale) < 0 &&
        store.state.full_loaded_locales.indexOf(locale) < 0
      ) {
        store.commit('ADD_LOADING_LOCALE', locale)
        app.$axios
          .$get('/i18n/public/loadStrings?locale=' + locale, {
            no_loading: true
          })
          .then(response => {
            if (response.resultCode === 'success') {
              const locales = []
              if (store.state.full_loaded_locales.indexOf(locale) < 0) {
                store.commit('FULL_LOADED_LOCALE', locale)
              }
              for (let i = 0; i < response.data.locales.length; i++) {
                locales.push({
                  text: response.data.locales[i].localeNm,
                  value: response.data.locales[i].locale
                })
              }
              store.commit('SET_LOCALES', locales)
              const messages = {}
              for (let i = 0; i < response.data.messages.length; i++) {
                messages[response.data.messages[i].code] =
                  response.data.messages[i].charst
              }
              store.commit('SET_MESSAGES', {
                locale: response.data.locale,
                messages: messages
              })
              store.commit('SET_LOCALE', response.data.locale)
              app.$moment.locale(response.data.locale)
              window._eventHub.$emit('refreshAll')
            } else {
              console.error('error')
              app.$toast.error('ERROR')
            }
          })
      } else {
        store.commit('SET_LOCALE', locale)
        app.$moment.locale(locale)
        window._eventHub.$emit('refreshAll')
      }
    },
    $td(defaultValue, id, obj, locale) {
      const msg = this.$t(id, obj, locale)
      if (!msg || msg === id) {
        return defaultValue
      }
      return msg
    },
    $t(id, obj, locale) {
      if (!id) {
        return
      }
      if (!locale) {
        locale = localStorage.locale
      }
      if (locale && store.state.messages && store.state.messages[locale]) {
        if (window._showI18nCode) {
          let code = 'code(' + id
          if (obj) {
            code += ' params(' + JSON.stringify(obj) + ')'
          }
          code += ')'
          return code
        }
        if (id.startsWith('menu.nm.') && id.endsWith('.logout')) {
          return store.state.messages[locale]['auth.button.logout']
        }
        if (store.state.messages[locale][id]) {
          let msg = store.state.messages[locale][id]
          if (obj) {
            for (const key in obj) {
              msg = msg.split('{' + key + '}').join(obj[key])
            }
          }
          return msg
        }
      }
      if (
        (!store.state.reported_undefined_messages[locale] ||
          !store.state.reported_undefined_messages[locale][id]) &&
        id !== 'validation.attribute.{field}' &&
        store.state.full_loaded_locales &&
        store.state.full_loaded_locales.length > 0
      ) {
        console.log(id + ' is not defined')
        store.commit('REPORT_UNDEFINED_MESSAGE', {
          locale: locale,
          key: id,
          stack: new Error().stack
        })
        app.$axios.$post(
          '/i18n/public/reportUndefinedString',
          {
            locale: locale,
            code: id,
            stack: new Error().stack
          },
          {
            no_loading: true
          }
        )
        if (this.configs && this.configs.defaultLocale) {
          locale = this.configs.defaultLocale
        } else {
          locale = 'en_us'
        }
        if (store.state.messages[locale] && store.state.messages[locale][id]) {
          // 기본 문자열을 반환
          return store.state.messages[locale][id]
        }
      }
      return id
    },
    getMessage(_, key, data) {
      const id = 'validation.message.' + key
      return this.$t(id, data)
    },
    setMessage(locale, key, value) {
      const id = 'validation.message.' + key
      store.commit('SET_MESSAGE', { locale, id, value })
    },
    getAttribute(_, key) {
      const id = 'validation.attribute.' + key
      return this.$t(id)
    },
    setAttribute(locale, key, value) {
      const id = 'validation.attribute.' + key
      store.commit('SET_MESSAGE', { locale, id, value })
    },
    getFieldMessage(_, field, rule, data) {
      const id = `validation.message.${field}.${rule}`
      if (
        localStorage.locale &&
        store.state.messages &&
        store.state.messages[localStorage.locale]
      ) {
        if (store.state.messages[localStorage.locale][id]) {
          return this.$t(id, data)
        }
      }
      if (data && data[0]) {
        data.field = data[0]
      }
      return this.getMessage(_, rule, data)
    },
    merge(dictionary) {
      if (store.state.messages) {
        store.state.messages = Object.assign(store.state.messages, dictionary)
      }
    },
    getDateFormat(locale) {
      if (store.state.messages && store.state.messages[locale]) {
        return store.state.messages[locale]['common.format.date']
      }
      return 'YYYY/MM/DD'
    },
    setDateFormat(locale, format) {
      if (store.state.messages && store.state.messages[locale]) {
        store.state.messages[locale]['common.format.date'] = format
      }
    }
  }
  inject('i18n', i18n)
  window._$t = i18n.$t
}

Vue.mixin({
  mounted: function() {
    this.$eventHub.$on('refreshStrings', this.onRefreshStrings)
  },
  methods: {
    hasNoText(key) {
      if (this.$store.state.messages[this.$store.state.locale][key]) {
        return true
      }
      return false
    },
    $t(key, obj, locale) {
      return this.$i18n.$t(key, obj, locale)
    },
    $td(defaultValue, key, obj, locale) {
      return this.$i18n.$td(defaultValue, key, obj, locale)
    },
    setI18nMessage(locale, key, value) {
      this.$store.commit('SET_MESSAGE', { locale, key, value })
    },
    onRefreshStrings() {
      this.$forceUpdate()
    },
    concatMessagesWithChar(input, ch) {
      if (!input || typeof input !== 'object' || input.length < 1) {
        return input
      }
      const ret = window.copyObject(input)
      for (let i = 0; i < ret.length; i++) {
        ret[i] = this.$t(ret[i])
      }
      return ret.join(ch)
    },
    translateStringMapFromServer(map) {
      if (!map) {
        return ''
      }
      if (map.multilanguage) {
        let params
        if (map.params && map.params.length > 0) {
          params = {}
          for (let i = 0; i < map.params.length; i++) {
            params[map.params[i].name] = this.translateStringMapFromServer(
              map.params[i]
            )
          }
        }
        return this.$t(map.value, params)
      }
      return map.value
    }
  }
})
